import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warnings and the CRA dev error overlay
// they trigger (lightweight-charts emits these on resize; they have no functional impact).
const RO_PATTERNS = [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
];
const isRO = (msg) => typeof msg === "string" && RO_PATTERNS.some((p) => msg.includes(p));

window.addEventListener(
    "error",
    (e) => {
        const msg = e?.message || e?.error?.message;
        if (isRO(msg)) {
            e.stopImmediatePropagation();
            e.preventDefault();
            return false;
        }
    },
    true,
);
window.addEventListener(
    "unhandledrejection",
    (e) => {
        const msg = e?.reason?.message || (typeof e?.reason === "string" ? e.reason : "");
        if (isRO(msg)) {
            e.stopImmediatePropagation();
            e.preventDefault();
        }
    },
    true,
);

// Disable react-error-overlay's runtime error reporting in dev (only takes effect in dev builds).
try {
    // eslint-disable-next-line global-require
    const reo = require("react-error-overlay");
    if (reo && typeof reo.stopReportingRuntimeErrors === "function") {
        reo.stopReportingRuntimeErrors();
    }
} catch (_) {
    /* not available in this build */
}

// Hide any CRA / react-error-overlay iframe that slips through (cosmetic in dev only).
const killOverlayIframe = () => {
    document.querySelectorAll("iframe").forEach((f) => {
        const id = (f.id || "").toLowerCase();
        const looksLikeOverlay =
            id.includes("webpack-dev-server-client-overlay") ||
            id.includes("react-error-overlay");
        if (looksLikeOverlay) {
            try { f.remove(); } catch (_) { f.style.display = "none"; }
        }
    });
};

killOverlayIframe();
setInterval(killOverlayIframe, 500);
new MutationObserver(killOverlayIframe).observe(document.documentElement, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
